import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { PrivacyNoticeDataProvider } from "../../data-provider/privacy-notice.dp";

let PrivacyNoticeFormComponent = {
    selector: "vcPrivacyNoticeForm",
    templateUrl:
        "/angular/components/privacy/privacy-notice-form.component.html",
    bindings: {
        privacyNotice: "=?",
        privacyNotices: "=?",
    },
    controller: class PrivacyNoticeFormController {
        // * bindings for typescript compiler *
        public privacyNotice?: any;
        public privacyNotices?: any;
        // ************************************

        private $scope: any;
        public dialog: DialogUtils;
        public dataProvider: PrivacyNoticeDataProvider;
        public privacyNoticeBodyIsEmpty = true;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            PrivacyNoticeDataProvider: PrivacyNoticeDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = PrivacyNoticeDataProvider;
        }

        $onInit() {
            if (angular.isDefined(this.privacyNotice)) {
                this.$scope.$watch(
                    () => this.privacyNotice.pnbody,
                    (newValue) => {
                        if (newValue) {
                            this.privacyNotice.pnbody = newValue.replace(
                                /<img[^>]*>/g,
                                ""
                            );
                        }

                        this.privacyNoticeBodyIsEmpty =
                            this.isValidPrivacyNoticeBody();
                    },
                    true
                );
            }
        }

        submitPrivacyNoticeForm() {
            this.dataProvider
                .create(this.privacyNotice)
                .then((privacyNotice) => {
                    this.addPrivacyNoticeToList(privacyNotice);
                    this.dialog.hide(privacyNotice);
                });
        }

        addPrivacyNoticeToList(privacyNotice) {
            this.privacyNotices.map((pn) => {
                pn.pnstatus = "Expired";
                return pn;
            });
            this.privacyNotices.unshift(privacyNotice);
        }

        cancel() {
            this.dialog.cancel();
        }

        stripTags(html) {
            let el = document.createElement("div");
            el.innerHTML = html;
            return (el.textContent || el.innerText || "").trim();
        }

        isValidPrivacyNoticeBody() {
            return (
                this.privacyNotice != null &&
                this.privacyNotice.pnbody != null &&
                this.stripTags(this.privacyNotice.pnbody) != ""
            );
        }
    },
};

angular
    .module("privacy")
    .component(PrivacyNoticeFormComponent.selector, PrivacyNoticeFormComponent);
